import { signal, batch } from "@preact/signals-react";

const msg = signal("");
const closeIcon = signal(true);
const openToast = signal(false);
const type = signal("error");
const name = signal({});

const toggleModal = ({
    name: namePayload,
    state: statePayload = false
}) =>{
    batch(()=>{
        name.value = {
            ...name.value,
            [namePayload]: statePayload,
        };
    })
}

const toggleToast = ({
    msg: msgPayload,
    state: statePayload = false,
    type: typePayload = 'error'

}) =>{
    batch(()=>{
        msg.value = msgPayload;
        openToast.value = statePayload;
        type.value = typePayload;
    })
}

export{
    msg,
    closeIcon,
    openToast,
    type,
    name,
    toggleModal,
    toggleToast
}